"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowCellRankProperty = exports.resultsTableRowCellRankPropertyDefinition = void 0;
exports.resultsTableRowCellRankPropertyDefinition = {
    view: { label: 'Results Table Row Cell Rank' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'oneOfProperties',
            argument: ['results-table-cell-value-rank'],
        },
    ],
    type: 'one-of-container',
    multiple: true,
    name: 'results-table-row-cell-rank',
};
const isResultsTableRowCellRankProperty = (prop) => {
    return prop.name === exports.resultsTableRowCellRankPropertyDefinition.name;
};
exports.isResultsTableRowCellRankProperty = isResultsTableRowCellRankProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3ctY2VsbC1yYW5rLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1yb3ctY2VsbC1yYW5rLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEseUNBQXlDLEdBQUc7SUFDdkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLDZCQUE2QixFQUFFO0lBQzlDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixRQUFRLEVBQUUsQ0FBQywrQkFBK0IsQ0FBQztTQUM1QztLQUNGO0lBQ0QsSUFBSSxFQUFFLGtCQUFrQjtJQUN4QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSw2QkFBNkI7Q0FDSixDQUFBO0FBSTFCLE1BQU0saUNBQWlDLEdBQUcsQ0FBQyxJQUFrQixFQUEyQyxFQUFFO0lBQy9HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxpREFBeUMsQ0FBQyxJQUFJLENBQUE7QUFDckUsQ0FBQyxDQUFBO0FBRlksUUFBQSxpQ0FBaUMscUNBRTdDIn0=